import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Users, CheckCircle2, Clock, FileText } from 'lucide-react';

const cards = [
  { key: 'total', title: 'Cəmi', icon: Users, iconColor: 'text-blue-600', valueColor: 'text-gray-900', testid: 'stat-total-card' },
  { key: 'new', title: 'Yeni', icon: FileText, iconColor: 'text-blue-600', valueColor: 'text-blue-700', testid: 'stat-new-card' },
  { key: 'inProgress', title: 'Baxılır', icon: Clock, iconColor: 'text-yellow-600', valueColor: 'text-yellow-700', testid: 'stat-in-progress-card' },
  { key: 'completed', title: 'Tamamlanmış', icon: CheckCircle2, iconColor: 'text-green-600', valueColor: 'text-green-700', testid: 'stat-completed-card' }
];

export const StatsCards = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
    {cards.map(({ key, title, icon: Icon, iconColor, valueColor, testid }) => (
      <Card key={key} data-testid={testid}>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium text-gray-600">{title}</CardTitle>
          <Icon className={`h-5 w-5 ${iconColor}`} />
        </CardHeader>
        <CardContent>
          <div className={`text-2xl sm:text-3xl font-bold ${valueColor}`}>{stats[key]}</div>
        </CardContent>
      </Card>
    ))}
  </div>
);
